import { FindParamsDefault } from './find-params-default';

export interface FindTruckParams extends FindParamsDefault {
  'id[]'?: string[];
  state?: string;
  market?: string;
  partner_id?: string;
}
